"use client"

interface InputProps {
  type?: string
  handler?: (e: React.ChangeEvent<HTMLInputElement>) => void
  name?: string
  label?: string
  value?: string
  placeHolder?: string
  onBlur?: () => void
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  disabled?: boolean
  customClass?: string
  inputRef?: React.Ref<HTMLInputElement>
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  onFocus?: (event: React.FocusEvent<HTMLInputElement, Element>) => void
  dataCy?: string
}

const FormInput: React.FC<InputProps> = ({
  type,
  handler,
  name,
  label,
  value,
  onBlur,
  onKeyPress,
  disabled = false,
  customClass,
  placeHolder,
  inputRef,
  onKeyDown,
  onFocus,
  dataCy,
}) => {
  return (
    <div className="flex flex-col gap-1 ">
      {label && (
        <label
          htmlFor={name}
          className="xs:text-xs font-normal text-black md:text-sm"
        >
          <span className="mr-1 text-red-600">*</span>
          {label}
        </label>
      )}
      <input
        type={type}
        onChange={handler}
        value={value}
        name={name}
        placeholder={placeHolder}
        // className="focus:shadow-outline h-12 w-full rounded border bg-white px-4 text-[16px] font-[600] focus:outline-none"
        className={`${customClass}`}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        disabled={disabled}
        onKeyDown={onKeyDown}
        ref={inputRef || undefined}
        onFocus={onFocus}
        data-cy={dataCy}
      />
    </div>
  )
}

export default FormInput
